import React, { useState, useEffect } from 'react'
import {
  Grid,
  GridColumn,
  GridNoRecords,
} from '@progress/kendo-react-grid'
import SearchContainer from '../../components/search/seachContainer'
import { groupBy } from '@progress/kendo-data-query'
import { IdiomaGrilla } from '../../helpers/stringHelpers'
import { sendAnalytics } from '../../utils/sendAnalytics'
import { ConcatNameTrack } from '../../helpers/stringHelpers'

const KendoGridPurchaseHistory = React.memo(props => {
  const {
    /** Dataset of the grid */
    data,
    /** Dataset total length (PAGINATION) */
    total,
    /** Columns definitions of the grid */
    columnsDefinition,
    /** Register button jsx */
    /** Double click on row action */
    rowDoubleClickAction = null,
    /** Style of the grid */
    // style = { marginTop: '20px', borderRadius: '0.2188rem', border: '0.0780rem solid #cccce0'},
    style = { marginTop: '20px' },
    /** Action for selected items on toolbar  */
    permissions,
    /** Recarga la tabla sin actualizar la pantalla */
    getList,
    /**Nombre del Grid */
    nameGrid,
  } = props
  const [localData, setLocalData] = useState([])
  const [selectedItems, setSelectedItems] = useState([])
  const [groupOperation, setGroupOperation] = useState([])
  const [localColumnsDefinition, setLocalColumnsDefinition] = useState(
    columnsDefinition
  )

  const [filterOperation, setFilterOperation] = useState({
    logic: 'and',
    filters: [],
  })

  const [pageOperation, setPageOperation] = useState(null)
  const [sortOperation, setSortOperation] = useState([])

  const [gridData, setGridData] = useState([])

  useEffect(() => {
    if (data) {
      let newLocalData = data.map(item => {
        return {
          ...item,
          selected: false,
        }
      })
      setLocalData(newLocalData)
    } else {
      setLocalData([])
      setGroupOperation([])
    }
  }, [data])

  const groupChange = ({ group }) => {
    let newLocalColumnsDefinition = []
    if (group.length === 0) {
      newLocalColumnsDefinition = localColumnsDefinition.filter(item => {
        item.group = false
        return true
      })

      setLocalColumnsDefinition(newLocalColumnsDefinition)
      setGroupOperation(group)
    } else {
      newLocalColumnsDefinition = localColumnsDefinition.filter(item => {
        item.group = false
        return true
      })

      for (let t = 0; t < group.length; t++) {
        var newLocalColumnsDefinition2 = newLocalColumnsDefinition.filter(
          item => {
            if (item.field === group[t].field) {
              item.group = true
              return true
            }
            return true
          }
        )
      }
      setLocalColumnsDefinition(newLocalColumnsDefinition2)
      setGroupOperation(group)
    }
  }

  const rowRender = (trElement, dataItem) => {
    const trProps = {
      ...trElement.props,
      onDoubleClick: () => rowDoubleClickAction(dataItem),
    }

    if (dataItem.rowType === 'groupFooter') {
      columnsDefinition.forEach(col => {
        let sum = 0
        if (col.aggregate) {
          let field = col.field
          dataItem.dataItem.items.forEach(e => (sum += Number(e[field])))
          dataItem.dataItem.aggregates[field] = {
            sum: sum,
          }
        }
      })
    }
    if (trElement.props.className === 'k-grouping-row') {
      return React.cloneElement(trElement, trElement.props.children)
    } else {
      return React.cloneElement(
        trElement,
        { ...trProps },
        trElement.props.children
      )
    }
  }

  const selectionChange = ({ dataItem }) => {
    let newLocalData = data.map(item => {
      if (item.id === dataItem.id) {
        item.selected = !item.selected
        if (item.selected) {
          setSelectedItems([...selectedItems, dataItem])
        } else {
          let filteredSelectedItems = selectedItems.filter(
            item => item.id !== dataItem.id
          )
          setSelectedItems(filteredSelectedItems)
        }
      }
      return item
    })
    setLocalData(newLocalData)
  }

  const selectAll = checked => {
    if (data) {
      let newLocalData = data.map(item => {
        item.selected = checked
        return item
      })
      if (checked) {
        setSelectedItems([...localData])
      } else {
        setSelectedItems([])
      }
      setLocalData(newLocalData)
    }
  }

  const headerSelectionChange = event => {
    const checked = event.syntheticEvent.target.checked
    selectAll(checked)
  }
  const pageChange = ({ page }) => {
    var Take
    if (page.take) {
      Take = page.take
    } else {
      Take = total
    }
    sendAnalytics('Cambio de página', {
      place: nameGrid,
      paginaAnterior: pageOperation
        ? Math.round(pageOperation.skip / pageOperation.take) + 1
        : 1,
      paginaActual: Math.round(page.skip / Take) + 1,
    })

    sendAnalytics('Cambio en paginación', {
      place: nameGrid,
      cantidadAnterior: pageOperation ? pageOperation.take : 10,
      cantidadActual: Take,
    })

    if (page.take) {
      setPageOperation({
        ...page,
        all: false,
      })
    } else {
      setPageOperation({
        skip: 0,
        take: total,
        all: true,
      })
    }
  }

  const filterChange = ({ filter }) => {
    if (filter) {
      sendAnalytics(ConcatNameTrack({ filter }), {
        place: nameGrid,
      })
    }
    setFilterOperation(filter)
    getList(filter)
  }

  const sortChange = ({ sort }) => {
    setSortOperation(sort)
  }

  const expandChange = event => {
    var newData = gridData
    const isExpanded =
      event.dataItem.expanded === undefined
        ? event.dataItem.aggregates
        : event.dataItem.expanded
    newData.forEach(element => {
      if (element.value === event.dataItem.value) {
        element.expanded = !isExpanded
      }
    })
    setGridData([...newData])
  }

  useEffect(() => {
    var newData = groupBy(localData, groupOperation)
    setGridData(newData)
  }, [localData, groupOperation])

  const ResizeChange = value => {
    if (value.end) {
      var validGroup = groupOperation.length > 0 ? true : false
      var counterGroup = groupOperation.length
      var newLocalColumnsDefinition = localColumnsDefinition.map(item => {
        var index = value.index
        if (validGroup) {
          index = value.index - counterGroup
        }
        if (value.columns[index].field === item.field) {
          item.width = value.newWidth
        } else {
          var findColumn = value.columns.find(
            column => column.field === item.field
          )
          if (findColumn) {
            if (!item.width) {
              item.width = findColumn.width
            }
          } else {
            item.width = CalculeTotalTable(value.columns)
          }
        }
        return item
      })
      setLocalColumnsDefinition(newLocalColumnsDefinition)
    }
  }

  const CalculeTotalTable = columns => {
    var total = 0
    columns.map(item => {
      var ColumnWidth = item.width
      total += parseFloat(ColumnWidth)
      return 0
    })
    var totalRound = Math.round(total) / (columns.length - 1)
    return totalRound
  }

  const cellRender = (td, props) => {
    if (
      td?.props.children &&
      props.rowType === 'groupHeader' &&
      props.dataItem.field === 'stage'
    ) {
      const stageDict = {
        '-2': 'En cola',
        '-1': 'Procesando',
        '1': 'Exitosa',
      }

      let children = (
        <span>{stageDict[props.dataItem.value] || 'No Procesado'}</span>
      )

      return React.cloneElement(td, td.props, children)
    }
    return td
  }

  return (
    <div style={style}>
      <IdiomaGrilla>
        <Grid
          data={gridData}
          selectedField="selected"
          onSelectionChange={selectionChange}
          onHeaderSelectionChange={headerSelectionChange}
          resizable
          filterable={true}
          rowRender={rowRender ? rowRender : null}
          sortable
          expandField="expanded"
          onExpandChange={expandChange}
          // pageable={{ pageSizes: [10, 20, 30, 50] }}
          total={total}
          //ref={gridRef}
          onGroupChange={groupChange}
          onPageChange={pageChange}
          onFilterChange={filterChange}
          onSortChange={sortChange}
          onColumnResize={ResizeChange}
          className="colorGreenGrid"
          group={groupOperation}
          filter={filterOperation}
          sort={sortOperation}
          cellRender={cellRender}
          {...pageOperation}
        >
          <GridNoRecords>
            <SearchContainer />
          </GridNoRecords>
          {/* <GridColumn field="selected" filterable={false} resizable={false} /> */}
          {localColumnsDefinition.map((object, i) => {
            if (object.visibility) {
              if (object.permissions) {
                if (permissions[object.permissions]) {
                  return (
                    <GridColumn {...object} key={`kendoWrapperGrid_${i}`} />
                  )
                }
              } else {
                return (
                  <GridColumn {...object} key={`kendoWrapperGrid_${i}`} />
                )
              }
            }
            return null
          })}
        </Grid>
      </IdiomaGrilla>
    </div>
  )

})

//KendoGridWrapper.whyDidYouRender = true
export default KendoGridPurchaseHistory
